//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class V1UsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    //custom code to format date without localization
    formatDateToLocalISO(date: Date): string {
        const pad = (num: number) => num.toString().padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteMultiFactorSetup(body?: DeleteMultiFactorSetupDto | undefined, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/mfa/google/setup";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMultiFactorSetup(_response);
        });
    }

    protected processDeleteMultiFactorSetup(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required", status, _responseText, _headers, result428);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    startGoogleAuthenticatorSetup( cancelToken?: CancelToken): Promise<GoogleAuthenticatorSetupDto> {
        let url_ = this.baseUrl + "/api/v1/users/mfa/google/setup";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartGoogleAuthenticatorSetup(_response);
        });
    }

    protected processStartGoogleAuthenticatorSetup(response: AxiosResponse): Promise<GoogleAuthenticatorSetupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = GoogleAuthenticatorSetupDto.fromJS(resultData200);
            return Promise.resolve<GoogleAuthenticatorSetupDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GoogleAuthenticatorSetupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    confirmGoogleAuthenticatorSetup(body?: ConfirmGoogleAuthenticatorSetupDto | undefined, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/mfa/google/setup";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmGoogleAuthenticatorSetup(_response);
        });
    }

    protected processConfirmGoogleAuthenticatorSetup(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @return No Content
     */
    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/logout";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data as string;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    verifyToken( cancelToken?: CancelToken): Promise<AuthenticationDto> {
        let url_ = this.baseUrl + "/api/v1/users/verify-token";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyToken(_response);
        });
    }

    protected processVerifyToken(response: AxiosResponse): Promise<AuthenticationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = AuthenticationDto.fromJS(resultData200);
            return Promise.resolve<AuthenticationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationDto>(null as any);
    }

    /**
     * @return OK
     */
    sendSmsMultiFactorCode( cancelToken?: CancelToken): Promise<SmsMultiFactorCodeSentDto> {
        let url_ = this.baseUrl + "/api/v1/users/mfa/sms";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendSmsMultiFactorCode(_response);
        });
    }

    protected processSendSmsMultiFactorCode(response: AxiosResponse): Promise<SmsMultiFactorCodeSentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = SmsMultiFactorCodeSentDto.fromJS(resultData200);
            return Promise.resolve<SmsMultiFactorCodeSentDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SmsMultiFactorCodeSentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    verifySmsMultiFactorCode(body?: VerifySmsMultiFactorCodeDto | undefined, cancelToken?: CancelToken): Promise<MultiFactorVerifiedDto> {
        let url_ = this.baseUrl + "/api/v1/users/mfa/sms";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifySmsMultiFactorCode(_response);
        });
    }

    protected processVerifySmsMultiFactorCode(response: AxiosResponse): Promise<MultiFactorVerifiedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = MultiFactorVerifiedDto.fromJS(resultData200);
            return Promise.resolve<MultiFactorVerifiedDto>(result200);

        } else if (status === 409) {
            const _responseText = response.data as string;
            let result409: any = null;
            let resultData409  = JSON.parse(_responseText);
            result409 = ApiResponseDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MultiFactorVerifiedDto>(null as any);
    }

    /**
     * @return OK
     */
    getUserMultiFactorSettings( cancelToken?: CancelToken): Promise<UserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/mfa/settings";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserMultiFactorSettings(_response);
        });
    }

    protected processGetUserMultiFactorSettings(response: AxiosResponse): Promise<UserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = UserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<UserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    verifyIsMultiFactorAuthenticated( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/users/mfa/verify";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyIsMultiFactorAuthenticated(_response);
        });
    }

    protected processVerifyIsMultiFactorAuthenticated(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getUserMobilePhone( cancelToken?: CancelToken): Promise<UserMobilePhoneDto> {
        let url_ = this.baseUrl + "/api/v1/users/mobile-phone";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserMobilePhone(_response);
        });
    }

    protected processGetUserMobilePhone(response: AxiosResponse): Promise<UserMobilePhoneDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = UserMobilePhoneDto.fromJS(resultData200);
            return Promise.resolve<UserMobilePhoneDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserMobilePhoneDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserMobilePhone(body?: UpdateUserMobilePhoneDto | undefined, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/mobile-phone";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserMobilePhone(_response);
        });
    }

    protected processUpdateUserMobilePhone(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required", status, _responseText, _headers, result428);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    login(body?: LoginDto | undefined, cancelToken?: CancelToken): Promise<AuthenticationDto> {
        let url_ = this.baseUrl + "/api/v1/users/login";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<AuthenticationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = AuthenticationDto.fromJS(resultData200);
            return Promise.resolve<AuthenticationDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    verifyGoogleAuthenticatorCode(body?: VerifyGoogleAuthenticatorCodeDto | undefined, cancelToken?: CancelToken): Promise<MultiFactorVerifiedDto> {
        let url_ = this.baseUrl + "/api/v1/users/mfa/google/verify";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyGoogleAuthenticatorCode(_response);
        });
    }

    protected processVerifyGoogleAuthenticatorCode(response: AxiosResponse): Promise<MultiFactorVerifiedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = MultiFactorVerifiedDto.fromJS(resultData200);
            return Promise.resolve<MultiFactorVerifiedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MultiFactorVerifiedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    enableGoogleAuthenticatorSetup(body?: EnableGoogleAuthenticatorSetupDto | undefined, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/mfa/google/setup/enable";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnableGoogleAuthenticatorSetup(_response);
        });
    }

    protected processEnableGoogleAuthenticatorSetup(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    forgotPassword(body?: ForgotPasswordDto | undefined, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/system-admin/forgot-password";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body?: ResetPasswordDto | undefined, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/system-admin/reset-password";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateUserPassword(body?: ValidateUserPasswordDto | undefined, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/password/validate";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateUserPassword(_response);
        });
    }

    protected processValidateUserPassword(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserPassword(body?: UpdateUserPasswordDto | undefined, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/password";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserPassword(_response);
        });
    }

    protected processUpdateUserPassword(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required", status, _responseText, _headers, result428);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getMenuItems( cancelToken?: CancelToken): Promise<MenuItemDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/menu";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuItems(_response);
        });
    }

    protected processGetMenuItems(response: AxiosResponse): Promise<MenuItemDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = MenuItemDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<MenuItemDtoNotPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MenuItemDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getMenuRoutes( cancelToken?: CancelToken): Promise<MenuRouteDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/menu/route";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuRoutes(_response);
        });
    }

    protected processGetMenuRoutes(response: AxiosResponse): Promise<MenuRouteDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = MenuRouteDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<MenuRouteDtoNotPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MenuRouteDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getUsers(deletedState: DeletedStateEnum, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<UsersDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users?";

                            if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<UsersDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = UsersDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<UsersDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UsersDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getApproveCaseUsers(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<UsersDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/users/with-approve-case?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApproveCaseUsers(_response);
        });
    }

    protected processGetApproveCaseUsers(response: AxiosResponse): Promise<UsersDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = UsersDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<UsersDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UsersDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    apiTest( cancelToken?: CancelToken): Promise<TestDto> {
        let url_ = this.baseUrl + "/api/v1/users/tests";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiTest(_response);
        });
    }

    protected processApiTest(response: AxiosResponse): Promise<TestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = TestDto.fromJS(resultData200);
            return Promise.resolve<TestDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestDto>(null as any);
    }
}

export class ApiResponseDto implements IApiResponseDto {
    id!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): ApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): ApiResponseDto {
        const json = this.toJSON();
        let result = new ApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IApiResponseDto {
    id: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class AuthenticationDto implements IAuthenticationDto {
    userId!: number;
    token!: string;
    multiFactorConfirmed!: boolean;
    multiFactorLoginEnabled!: boolean;
    homePage?: string | undefined;
    permissions!: number[];

    constructor(data?: IAuthenticationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.token = _data["token"];
            this.multiFactorConfirmed = _data["multiFactorConfirmed"];
            this.multiFactorLoginEnabled = _data["multiFactorLoginEnabled"];
            this.homePage = _data["homePage"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): AuthenticationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["token"] = this.token;
        data["multiFactorConfirmed"] = this.multiFactorConfirmed;
        data["multiFactorLoginEnabled"] = this.multiFactorLoginEnabled;
        data["homePage"] = this.homePage;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }

    clone(): AuthenticationDto {
        const json = this.toJSON();
        let result = new AuthenticationDto();
        result.init(json);
        return result;
    }
}

export interface IAuthenticationDto {
    userId: number;
    token: string;
    multiFactorConfirmed: boolean;
    multiFactorLoginEnabled: boolean;
    homePage?: string | undefined;
    permissions: number[];
}

export class ConfirmGoogleAuthenticatorSetupDto implements IConfirmGoogleAuthenticatorSetupDto {
    code?: string | undefined;

    constructor(data?: IConfirmGoogleAuthenticatorSetupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ConfirmGoogleAuthenticatorSetupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmGoogleAuthenticatorSetupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }

    clone(): ConfirmGoogleAuthenticatorSetupDto {
        const json = this.toJSON();
        let result = new ConfirmGoogleAuthenticatorSetupDto();
        result.init(json);
        return result;
    }
}

export interface IConfirmGoogleAuthenticatorSetupDto {
    code?: string | undefined;
}

export class DeleteMultiFactorSetupDto implements IDeleteMultiFactorSetupDto {
    multiFactorType!: MultiFactorTypeEnum;
    multiFactorGuid!: string;

    constructor(data?: IDeleteMultiFactorSetupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiFactorType = _data["multiFactorType"];
            this.multiFactorGuid = _data["multiFactorGuid"];
        }
    }

    static fromJS(data: any): DeleteMultiFactorSetupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMultiFactorSetupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiFactorType"] = this.multiFactorType;
        data["multiFactorGuid"] = this.multiFactorGuid;
        return data;
    }

    clone(): DeleteMultiFactorSetupDto {
        const json = this.toJSON();
        let result = new DeleteMultiFactorSetupDto();
        result.init(json);
        return result;
    }
}

export interface IDeleteMultiFactorSetupDto {
    multiFactorType: MultiFactorTypeEnum;
    multiFactorGuid: string;
}

export enum DeletedStateEnum {
    Undefined = "Undefined",
    Active = "Active",
    Deleted = "Deleted",
    Both = "Both",
}

export class EnableGoogleAuthenticatorSetupDto implements IEnableGoogleAuthenticatorSetupDto {
    multiFactorGuid!: string;

    constructor(data?: IEnableGoogleAuthenticatorSetupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiFactorGuid = _data["multiFactorGuid"];
        }
    }

    static fromJS(data: any): EnableGoogleAuthenticatorSetupDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnableGoogleAuthenticatorSetupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiFactorGuid"] = this.multiFactorGuid;
        return data;
    }

    clone(): EnableGoogleAuthenticatorSetupDto {
        const json = this.toJSON();
        let result = new EnableGoogleAuthenticatorSetupDto();
        result.init(json);
        return result;
    }
}

export interface IEnableGoogleAuthenticatorSetupDto {
    multiFactorGuid: string;
}

export class ForgotPasswordDto implements IForgotPasswordDto {
    username?: string | undefined;

    constructor(data?: IForgotPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): ForgotPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }

    clone(): ForgotPasswordDto {
        const json = this.toJSON();
        let result = new ForgotPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordDto {
    username?: string | undefined;
}

export class GoogleAuthenticatorSetupDto implements IGoogleAuthenticatorSetupDto {
    manualEntryKey?: string | undefined;
    qrCodeSetupImageUrl?: string | undefined;

    constructor(data?: IGoogleAuthenticatorSetupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manualEntryKey = _data["manualEntryKey"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): GoogleAuthenticatorSetupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleAuthenticatorSetupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manualEntryKey"] = this.manualEntryKey;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    }

    clone(): GoogleAuthenticatorSetupDto {
        const json = this.toJSON();
        let result = new GoogleAuthenticatorSetupDto();
        result.init(json);
        return result;
    }
}

export interface IGoogleAuthenticatorSetupDto {
    manualEntryKey?: string | undefined;
    qrCodeSetupImageUrl?: string | undefined;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class LoginDto implements ILoginDto {
    password!: string;
    userName!: string;

    constructor(data?: ILoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): LoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["userName"] = this.userName;
        return data;
    }

    clone(): LoginDto {
        const json = this.toJSON();
        let result = new LoginDto();
        result.init(json);
        return result;
    }
}

export interface ILoginDto {
    password: string;
    userName: string;
}

export class MenuItemDto implements IMenuItemDto {
    tabId!: number;
    sortOrder!: number;
    tabName?: string | undefined;
    tabUrl?: string | undefined;
    userTabId!: number;
    permissionId?: number | undefined;
    parentTabId!: number;
    newDcsUrl!: boolean;
    menuItems?: MenuItemDto[] | undefined;

    constructor(data?: IMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabId = _data["tabId"];
            this.sortOrder = _data["sortOrder"];
            this.tabName = _data["tabName"];
            this.tabUrl = _data["tabUrl"];
            this.userTabId = _data["userTabId"];
            this.permissionId = _data["permissionId"];
            this.parentTabId = _data["parentTabId"];
            this.newDcsUrl = _data["newDcsUrl"];
            if (Array.isArray(_data["menuItems"])) {
                this.menuItems = [] as any;
                for (let item of _data["menuItems"])
                    this.menuItems!.push(MenuItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabId"] = this.tabId;
        data["sortOrder"] = this.sortOrder;
        data["tabName"] = this.tabName;
        data["tabUrl"] = this.tabUrl;
        data["userTabId"] = this.userTabId;
        data["permissionId"] = this.permissionId;
        data["parentTabId"] = this.parentTabId;
        data["newDcsUrl"] = this.newDcsUrl;
        if (Array.isArray(this.menuItems)) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): MenuItemDto {
        const json = this.toJSON();
        let result = new MenuItemDto();
        result.init(json);
        return result;
    }
}

export interface IMenuItemDto {
    tabId: number;
    sortOrder: number;
    tabName?: string | undefined;
    tabUrl?: string | undefined;
    userTabId: number;
    permissionId?: number | undefined;
    parentTabId: number;
    newDcsUrl: boolean;
    menuItems?: MenuItemDto[] | undefined;
}

export class MenuItemDtoNotPagedDataResponseDto implements IMenuItemDtoNotPagedDataResponseDto {
    data!: MenuItemDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IMenuItemDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MenuItemDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): MenuItemDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItemDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): MenuItemDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new MenuItemDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IMenuItemDtoNotPagedDataResponseDto {
    data: MenuItemDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class MenuRouteDto implements IMenuRouteDto {
    tabId!: number;
    tabRouteSysAdminId!: number;
    route?: string | undefined;
    componentName?: string | undefined;
    title?: string | undefined;
    productName?: string | undefined;
    permissionId?: number | undefined;
    hideHeader?: boolean | undefined;

    constructor(data?: IMenuRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabId = _data["tabId"];
            this.tabRouteSysAdminId = _data["tabRouteSysAdminId"];
            this.route = _data["route"];
            this.componentName = _data["componentName"];
            this.title = _data["title"];
            this.productName = _data["productName"];
            this.permissionId = _data["permissionId"];
            this.hideHeader = _data["hideHeader"];
        }
    }

    static fromJS(data: any): MenuRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabId"] = this.tabId;
        data["tabRouteSysAdminId"] = this.tabRouteSysAdminId;
        data["route"] = this.route;
        data["componentName"] = this.componentName;
        data["title"] = this.title;
        data["productName"] = this.productName;
        data["permissionId"] = this.permissionId;
        data["hideHeader"] = this.hideHeader;
        return data;
    }

    clone(): MenuRouteDto {
        const json = this.toJSON();
        let result = new MenuRouteDto();
        result.init(json);
        return result;
    }
}

export interface IMenuRouteDto {
    tabId: number;
    tabRouteSysAdminId: number;
    route?: string | undefined;
    componentName?: string | undefined;
    title?: string | undefined;
    productName?: string | undefined;
    permissionId?: number | undefined;
    hideHeader?: boolean | undefined;
}

export class MenuRouteDtoNotPagedDataResponseDto implements IMenuRouteDtoNotPagedDataResponseDto {
    data!: MenuRouteDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IMenuRouteDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MenuRouteDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): MenuRouteDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuRouteDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): MenuRouteDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new MenuRouteDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IMenuRouteDtoNotPagedDataResponseDto {
    data: MenuRouteDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export enum MultiFactorTypeEnum {
    Undefined = "Undefined",
    Sms = "Sms",
    Google = "Google",
}

export class MultiFactorVerifiedDto implements IMultiFactorVerifiedDto {
    multiFactorConfirmed!: boolean;
    multiFactorConfirmRenewalDate!: Date;
    multiFactorGuid!: string;
    multiFactorGuidExpireDate!: Date;

    constructor(data?: IMultiFactorVerifiedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiFactorConfirmed = _data["multiFactorConfirmed"];
            this.multiFactorConfirmRenewalDate = _data["multiFactorConfirmRenewalDate"] ? new Date(_data["multiFactorConfirmRenewalDate"].toString()) : <any>undefined;
            this.multiFactorGuid = _data["multiFactorGuid"];
            this.multiFactorGuidExpireDate = _data["multiFactorGuidExpireDate"] ? new Date(_data["multiFactorGuidExpireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MultiFactorVerifiedDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiFactorVerifiedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiFactorConfirmed"] = this.multiFactorConfirmed;
        data["multiFactorConfirmRenewalDate"] = this.multiFactorConfirmRenewalDate ? this.multiFactorConfirmRenewalDate.toISOString() : <any>undefined;
        data["multiFactorGuid"] = this.multiFactorGuid;
        data["multiFactorGuidExpireDate"] = this.multiFactorGuidExpireDate ? this.multiFactorGuidExpireDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): MultiFactorVerifiedDto {
        const json = this.toJSON();
        let result = new MultiFactorVerifiedDto();
        result.init(json);
        return result;
    }
}

export interface IMultiFactorVerifiedDto {
    multiFactorConfirmed: boolean;
    multiFactorConfirmRenewalDate: Date;
    multiFactorGuid: string;
    multiFactorGuidExpireDate: Date;
}

export class ResetPasswordDto implements IResetPasswordDto {
    resetCode!: string;
    newPassword!: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resetCode = _data["resetCode"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resetCode"] = this.resetCode;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    resetCode: string;
    newPassword: string;
}

export class SmsMultiFactorCodeSentDto implements ISmsMultiFactorCodeSentDto {
    mobilePhone?: string | undefined;
    email?: string | undefined;
    expireMinutes!: number;

    constructor(data?: ISmsMultiFactorCodeSentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobilePhone = _data["mobilePhone"];
            this.email = _data["email"];
            this.expireMinutes = _data["expireMinutes"];
        }
    }

    static fromJS(data: any): SmsMultiFactorCodeSentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmsMultiFactorCodeSentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobilePhone"] = this.mobilePhone;
        data["email"] = this.email;
        data["expireMinutes"] = this.expireMinutes;
        return data;
    }

    clone(): SmsMultiFactorCodeSentDto {
        const json = this.toJSON();
        let result = new SmsMultiFactorCodeSentDto();
        result.init(json);
        return result;
    }
}

export interface ISmsMultiFactorCodeSentDto {
    mobilePhone?: string | undefined;
    email?: string | undefined;
    expireMinutes: number;
}

export class TestDto implements ITestDto {
    prop?: string | undefined;

    constructor(data?: ITestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prop = _data["prop"];
        }
    }

    static fromJS(data: any): TestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prop"] = this.prop;
        return data;
    }

    clone(): TestDto {
        const json = this.toJSON();
        let result = new TestDto();
        result.init(json);
        return result;
    }
}

export interface ITestDto {
    prop?: string | undefined;
}

export class UpdateUserMobilePhoneDto implements IUpdateUserMobilePhoneDto {
    mobilePhoneNumber?: string | undefined;
    multiFactorGuid!: string;

    constructor(data?: IUpdateUserMobilePhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.multiFactorGuid = _data["multiFactorGuid"];
        }
    }

    static fromJS(data: any): UpdateUserMobilePhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserMobilePhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["multiFactorGuid"] = this.multiFactorGuid;
        return data;
    }

    clone(): UpdateUserMobilePhoneDto {
        const json = this.toJSON();
        let result = new UpdateUserMobilePhoneDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserMobilePhoneDto {
    mobilePhoneNumber?: string | undefined;
    multiFactorGuid: string;
}

export class UpdateUserPasswordDto implements IUpdateUserPasswordDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;
    multiFactorGuid!: string;

    constructor(data?: IUpdateUserPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmNewPassword = _data["confirmNewPassword"];
            this.multiFactorGuid = _data["multiFactorGuid"];
        }
    }

    static fromJS(data: any): UpdateUserPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["confirmNewPassword"] = this.confirmNewPassword;
        data["multiFactorGuid"] = this.multiFactorGuid;
        return data;
    }

    clone(): UpdateUserPasswordDto {
        const json = this.toJSON();
        let result = new UpdateUserPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserPasswordDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;
    multiFactorGuid: string;
}

export class UserMobilePhoneDto implements IUserMobilePhoneDto {
    mobilePhoneNumber?: string | undefined;

    constructor(data?: IUserMobilePhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
        }
    }

    static fromJS(data: any): UserMobilePhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserMobilePhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        return data;
    }

    clone(): UserMobilePhoneDto {
        const json = this.toJSON();
        let result = new UserMobilePhoneDto();
        result.init(json);
        return result;
    }
}

export interface IUserMobilePhoneDto {
    mobilePhoneNumber?: string | undefined;
}

export class UserMultiFactorSettingsJoinedDto implements IUserMultiFactorSettingsJoinedDto {
    multiFactorTypeId!: MultiFactorTypeEnum;
    userMultiFactorSettingId?: number | undefined;
    logoUrl?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    enabled!: boolean;
    recommended!: boolean;
    sortOrder!: number;

    constructor(data?: IUserMultiFactorSettingsJoinedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiFactorTypeId = _data["multiFactorTypeId"];
            this.userMultiFactorSettingId = _data["userMultiFactorSettingId"];
            this.logoUrl = _data["logoUrl"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.recommended = _data["recommended"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UserMultiFactorSettingsJoinedDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserMultiFactorSettingsJoinedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiFactorTypeId"] = this.multiFactorTypeId;
        data["userMultiFactorSettingId"] = this.userMultiFactorSettingId;
        data["logoUrl"] = this.logoUrl;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["recommended"] = this.recommended;
        data["sortOrder"] = this.sortOrder;
        return data;
    }

    clone(): UserMultiFactorSettingsJoinedDto {
        const json = this.toJSON();
        let result = new UserMultiFactorSettingsJoinedDto();
        result.init(json);
        return result;
    }
}

export interface IUserMultiFactorSettingsJoinedDto {
    multiFactorTypeId: MultiFactorTypeEnum;
    userMultiFactorSettingId?: number | undefined;
    logoUrl?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    enabled: boolean;
    recommended: boolean;
    sortOrder: number;
}

export class UserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto implements IUserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto {
    data!: UserMultiFactorSettingsJoinedDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IUserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserMultiFactorSettingsJoinedDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): UserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): UserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new UserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IUserMultiFactorSettingsJoinedDtoNotPagedDataResponseDto {
    data: UserMultiFactorSettingsJoinedDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class UsersDto implements IUsersDto {
    usersId!: number;
    dealerId!: number;
    dealerGroupId?: number | undefined;
    roleId!: number;
    username?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    deleted!: boolean;
    createdById!: number;
    createdDate!: Date;
    lastModifiedById!: number;
    lastModifiedDate!: Date;
    emailAddress?: string | undefined;
    primaryUser!: boolean;
    dcsextension?: number | undefined;
    userTitleId?: number | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    carrierId?: number | undefined;
    enableMobileReports!: boolean;
    dashboard!: boolean;
    homePage?: string | undefined;

    constructor(data?: IUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usersId = _data["usersId"];
            this.dealerId = _data["dealerId"];
            this.dealerGroupId = _data["dealerGroupId"];
            this.roleId = _data["roleId"];
            this.username = _data["username"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.deleted = _data["deleted"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedById = _data["lastModifiedById"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.primaryUser = _data["primaryUser"];
            this.dcsextension = _data["dcsextension"];
            this.userTitleId = _data["userTitleId"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.carrierId = _data["carrierId"];
            this.enableMobileReports = _data["enableMobileReports"];
            this.dashboard = _data["dashboard"];
            this.homePage = _data["homePage"];
        }
    }

    static fromJS(data: any): UsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usersId"] = this.usersId;
        data["dealerId"] = this.dealerId;
        data["dealerGroupId"] = this.dealerGroupId;
        data["roleId"] = this.roleId;
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["deleted"] = this.deleted;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedById"] = this.lastModifiedById;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["primaryUser"] = this.primaryUser;
        data["dcsextension"] = this.dcsextension;
        data["userTitleId"] = this.userTitleId;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["carrierId"] = this.carrierId;
        data["enableMobileReports"] = this.enableMobileReports;
        data["dashboard"] = this.dashboard;
        data["homePage"] = this.homePage;
        return data;
    }

    clone(): UsersDto {
        const json = this.toJSON();
        let result = new UsersDto();
        result.init(json);
        return result;
    }
}

export interface IUsersDto {
    usersId: number;
    dealerId: number;
    dealerGroupId?: number | undefined;
    roleId: number;
    username?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    deleted: boolean;
    createdById: number;
    createdDate: Date;
    lastModifiedById: number;
    lastModifiedDate: Date;
    emailAddress?: string | undefined;
    primaryUser: boolean;
    dcsextension?: number | undefined;
    userTitleId?: number | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    carrierId?: number | undefined;
    enableMobileReports: boolean;
    dashboard: boolean;
    homePage?: string | undefined;
}

export class UsersDtoPagedDataResponseDto implements IUsersDtoPagedDataResponseDto {
    data!: UsersDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IUsersDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UsersDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): UsersDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): UsersDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new UsersDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IUsersDtoPagedDataResponseDto {
    data: UsersDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class ValidateUserPasswordDto implements IValidateUserPasswordDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;

    constructor(data?: IValidateUserPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmNewPassword = _data["confirmNewPassword"];
        }
    }

    static fromJS(data: any): ValidateUserPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateUserPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["confirmNewPassword"] = this.confirmNewPassword;
        return data;
    }

    clone(): ValidateUserPasswordDto {
        const json = this.toJSON();
        let result = new ValidateUserPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IValidateUserPasswordDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;
}

export class VerifyGoogleAuthenticatorCodeDto implements IVerifyGoogleAuthenticatorCodeDto {
    code?: string | undefined;

    constructor(data?: IVerifyGoogleAuthenticatorCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): VerifyGoogleAuthenticatorCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyGoogleAuthenticatorCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }

    clone(): VerifyGoogleAuthenticatorCodeDto {
        const json = this.toJSON();
        let result = new VerifyGoogleAuthenticatorCodeDto();
        result.init(json);
        return result;
    }
}

export interface IVerifyGoogleAuthenticatorCodeDto {
    code?: string | undefined;
}

export class VerifySmsMultiFactorCodeDto implements IVerifySmsMultiFactorCodeDto {
    code?: string | undefined;

    constructor(data?: IVerifySmsMultiFactorCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): VerifySmsMultiFactorCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsMultiFactorCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }

    clone(): VerifySmsMultiFactorCodeDto {
        const json = this.toJSON();
        let result = new VerifySmsMultiFactorCodeDto();
        result.init(json);
        return result;
    }
}

export interface IVerifySmsMultiFactorCodeDto {
    code?: string | undefined;
}

export class V1ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isV1ApiException = true;

    static isV1ApiException(obj: any): obj is V1ApiException {
        return obj.isV1ApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new V1ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}